import { forwardRef, Select, SelectItem } from '@heroui/react'
import { useSchemas } from 'components/Dashboard/Analysis/utils'


const CitationSchemaSelect = forwardRef(({ value, ...props }, ref) => {
  const { data: schemas, isLoading: schemasLoading } = useSchemas()
  return (
    <Select
      isLoading={schemasLoading}
      labelPlacement="outside"
      variant="bordered"
      radius="sm"
      isVirtualized
      placeholder="Select a schema"
      description="Select a Citation Schema to use for this call. Citation Schemas define the structure for extracting specific citations from the call."
      label="Citation Schema"
      selectedKeys={value && [value]}
      {...props}
      ref={ref}
    >
      {schemas?.map(schema => (
        <SelectItem key={schema.id}>
          {schema.name ?? 'Untitled Citation Schema'}
        </SelectItem>
      ))}
    </Select>
  )
})

export default CitationSchemaSelect
